import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { name: "Inicio", path: "/" },
  { name: "Nosotros", path: "/nosotros" },
  { name: "Servicios", path: "/servicios" },
  { name: "Cómo funciona", path: "/como-funciona" },
  { name: "Preguntas", path: "/preguntas" },
  { name: "Postula", path: "/postula" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header
      data-testid="main-header"
      className="sticky top-0 z-50 backdrop-blur-md bg-ivory/90 border-b border-line/80"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-brand" className="flex flex-col leading-none" onClick={() => setOpen(false)}>
          <span className="font-serif text-2xl tracking-wide text-ink">Exclusive</span>
          <span className="text-[10px] uppercase tracking-[0.35em] text-mauve font-sans font-semibold">
            Society
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8" data-testid="nav-desktop">
          {LINKS.map((l) => (
            <NavLink
              key={l.path}
              to={l.path}
              data-testid={`nav-link-${l.path === "/" ? "inicio" : l.path.slice(1)}`}
              className={({ isActive }) =>
                `text-xs uppercase tracking-[0.18em] font-sans transition-colors duration-300 ${
                  isActive ? "text-ink font-semibold" : "text-stone2 hover:text-mauve"
                }`
              }
            >
              {l.name}
            </NavLink>
          ))}
          <Link
            to="/postula"
            data-testid="nav-cta-oportunidad"
            className="bg-plum text-ivory hover:bg-mauve px-6 py-3 text-xs uppercase tracking-[0.18em] transition-colors duration-300 font-sans"
          >
            Conoce la oportunidad
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-ink"
          onClick={() => setOpen(!open)}
          aria-label="Abrir menú"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <nav
          data-testid="nav-mobile"
          className="lg:hidden border-t border-line bg-ivory px-4 sm:px-8 py-6 flex flex-col gap-5"
        >
          {LINKS.map((l) => (
            <NavLink
              key={l.path}
              to={l.path}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${l.path === "/" ? "inicio" : l.path.slice(1)}`}
              className={`text-sm uppercase tracking-[0.18em] font-sans ${
                location.pathname === l.path ? "text-ink font-semibold" : "text-stone2"
              }`}
            >
              {l.name}
            </NavLink>
          ))}
          <Link
            to="/postula"
            onClick={() => setOpen(false)}
            data-testid="nav-mobile-cta-oportunidad"
            className="bg-plum text-ivory text-center px-6 py-4 text-xs uppercase tracking-[0.18em] font-sans mt-2"
          >
            Conoce la oportunidad
          </Link>
        </nav>
      )}
    </header>
  );
};
